import { SuperAgentStatic } from 'superagent';
import { SPAREMIN_SERVICES_EDDY_URL } from 'config';
import { createRequest } from '../utils';
import * as types from './types';

const BASE_PATH = '/api/v1/eddy';
const PROJECT_PATH = `${BASE_PATH}/project`;

async function createEddyProject(
  request: SuperAgentStatic,
  [name, associatedMedia]: types.CreateEddyProjectActionArgs,
): Promise<types.CreateEddyProjectResult> {
  const { body } = await request
    .post(PROJECT_PATH)
    .send({ associatedMedias: [associatedMedia], name });

  return body;
}

async function getEddyProject(
  request: SuperAgentStatic,
  [projectCuid]: types.GetEddyProjectActionArgs,
): Promise<types.GetEddyProjectResult> {
  const { body } = await request.get(`${PROJECT_PATH}/${projectCuid}`);

  return body;
}

export function handle(method: any, args: any, token: string) {
  const request = createRequest({
    token,
    baseUrl: SPAREMIN_SERVICES_EDDY_URL,
  });

  switch (method) {
    case types.ServiceMethod.CREATE_EDDY_PROJECT:
      return createEddyProject(request, args);

    case types.ServiceMethod.GET_EDDY_PROJECT:
      return getEddyProject(request, args);

    default:
      return undefined;
  }
}
